// extracted by mini-css-extract-plugin
module.exports = {"root":"UH-YI-_w0HVIL09KOs0IQ"};